module.exports = __webpack_public_path__ + "img/sentinel-logo.1e33cd93.png";